export const SEARCH_ATTRIBUTES_TRANSLATION_SECTION = 'DMS_searchAttributes';

export const toTranslationKey = (value: string): string =>
  value
    .trim()
    .split(/[\s-]+/u)
    .filter(Boolean)
    .map((word, index) => {
      const normalized = word.toLocaleLowerCase();
      return index === 0
        ? normalized
        : `${normalized.charAt(0).toLocaleUpperCase()}${normalized.slice(1)}`;
    })
    .join('');

export const searchAttributeTranslationKey = (
  name: string,
  allowedValue?: string,
): string => {
  const nameKey = toTranslationKey(name);
  return allowedValue === undefined
    ? nameKey
    : `${nameKey}_${toTranslationKey(allowedValue)}`;
};

export const searchAttributeTranslationUrl = (translationKey: string): string => {
  const parameters = new URLSearchParams({
    search: translationKey,
    sectionFilter: SEARCH_ATTRIBUTES_TRANSLATION_SECTION,
  });
  return `/mtm/translations?${parameters.toString()}`;
};